import React from 'react';

import baseLoadable from '@loadable/component';
import type { DefaultComponent } from '@loadable/component';

import Spinner from '~/components/Common/Spinner';

export const FallbackLoader = Spinner;

export default function <T>(func: () => Promise<DefaultComponent<T>>, fallback = <Spinner />) {
  return baseLoadable(func, { fallback });
}
